const consoleImage = (url) => {
    var xhr = new XMLHttpRequest();
    xhr.open('get', url);
    xhr.responseType = 'blob';
    xhr.onload = function(){
        var fr = new FileReader();

        fr.onload = function(){
            const style = `font-size: 300px; background-image: url("${this.result}"); background-size: contain; background-repeat: no-repeat;`;
            console.log("%c     ", style);
        };
        fr.readAsDataURL(xhr.response); // async call
    };
    xhr.send();
}

export default consoleImage